import styled from 'styled-components';
import {
	WHITE_COLOR,
	RED_COLOR,
	GREEN_COLOR_1,
} from '../../config/colors';

export const Wrapper = styled.div`
	h2 {
		border-top: 2px solid #A8A8B1;
	}
	.sub-head {
		color: #F83E1B;
		font-size: 0.75rem;
	}
	.two-factor {
		.anticon {
			&.anticon-right {
				&.ant-collapse-arrow {
					top: 35%;
				}
			} 
		}
	}
	.ant-form {
		padding: 14px 0px !important;
	}
	.ex-tags {
		span {
			padding: 2px 3px;
			margin-left: 8px;
			color: ${WHITE_COLOR};
			border-radius: 4px;
		}
		.active {
			background-color: ${GREEN_COLOR_1};
		}
		.Inactive {
			background-color: ${RED_COLOR};
		}
	}
	.border-none {
		border-top: none !important;
	}
	.otp_form-wrapper {
		display: flex;
		flex-direction: column;

		.otp_form-section-wrapper {
			border-top: 2px solid #A8A8B1;
			padding: 0.75rem 0;

			.otp_form-section-content {
				margin: 1rem 0;
				.qr-code-wrapper {
					text-align: center;
					margin: 0.5rem;
				}
			}

			.otp_form-section-title {
				font-size: 1rem;
				font-weight: bold;
			}

			.otp_form-section-text {
				font-size: 0.875rem;
			}

			.otp_secret {
				font-size: 0.9rem;
				background-color: #212121;
				padding: 0.25rem 0.5rem;
				word-break: break-all;
			}
		}

		.otp_form-fields-wrapper {
			margin-bottom: 1rem;
		}

		.icon_title-wrapper {
			.icon_title-text.title {
				font-size: 1.75rem;
			}
		}
	}
`;

export const wrapStyle = {
	padding: '14px 24px'
};
